/* RESPONSIBLE TEAM: team-automation-foundations */
import { helper } from '@ember/component/helper';
import { roleNames, audienceNames } from 'embercom/models/data/matching-system/matching-constants';
import toSentence from 'embercom/lib/to-sentence';
import { pluralize } from 'ember-inflector';
import { capitalize } from '@ember/string';

export function audienceTypes(roles) {
  roles = roles || [];
  let names = roles.map((role) => capitalize(pluralize(roleNames[role])));
  return toSentence(names);
}

// Translates a role string constant (e.g. "user_role") to a display label (e.g. "Users")
export function audienceRoleLabel(role) {
  let name = audienceNames[role];
  return name ? capitalize(pluralize(name)) : role;
}

function audienceTypesHelper([roles]) {
  return audienceTypes(roles);
}

export default helper(audienceTypesHelper);
